

















import Vue from "vue"
export default Vue.extend({
  name: "notification-snackbar",
  props:{
    isvisible: Boolean,
    innertext: String,
  },

  methods:{
    on_click(){
      (this as any).$emit("evtclose",1)
    }
  }

})
